import { createReducer } from '@reduxjs/toolkit';

import { SponsorBannerDto } from '../models/dto/sponsor-banner-dto';
import { sponsorBannersReceived } from './sponsor-banner-actions';

export interface SponsorBannerState {
    banners: SponsorBannerDto[];
}

const initialState: SponsorBannerState = {
    banners: [],
};

export const sponsorBannersReducer = createReducer(initialState, builder => {
    builder.addCase(sponsorBannersReceived, (state, action) => ({ ...state, banners: action.payload }));
});
